import React, {FC, useEffect, useMemo, useState} from 'react';
import {WinnerEntry} from "../../../util/hooks/useWishCountdown";
import {Theme} from "@mui/material/styles";
import {SxProps} from "@mui/system";
import {IWinnerTicket, IWish} from "../../../store/wish/Helper";
import WinnersButton from "./WinnersButton";
import WinnerDisplay from "./WinnerDisplay";

interface IProps {
    thumbnail: string;
    tickets: WinnerEntry[];
    winners: IWinnerTicket[]
    color: string
    sx?: SxProps<Theme>
    wish?: IWish
    buttonColor?: "primary" | "secondary" | "tertiary"
    buttonSize?: "small" | "medium"
}

const CardWinnerPicker: FC<IProps> = ({buttonSize = "small", ...props}) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const hasWinners = useMemo(() => (
        (props.wish?.winners?.length ?? 0) > 0 || (props.winners?.length ?? 0) > 0
    ), [props.wish?.winners, props.winners]);


    // Cycle through tickets before winners are announced
    useEffect(() => {
        if (hasWinners || props.tickets.length === 0) return;

        const intervalId = setInterval(() => {
            setCurrentIndex(prevIndex => (prevIndex + 1) % props.tickets.length);
        }, 200);
        return () => clearInterval(intervalId);
    }, [props.tickets.length, hasWinners]);

    const currentEntry = props.tickets.length > 0 ? props.tickets[currentIndex % props.tickets.length] : null;

    if (hasWinners) {
        return (
            <WinnersButton
                wish={props.wish!}
                winners={props.winners}
                buttonColor={props.buttonColor}
                buttonSize={buttonSize}
            />
        );
    }

    return <WinnerDisplay entry={currentEntry} color={props.color} sx={props.sx}/>;
};

export default CardWinnerPicker;
